import { useFirestoreGeneral } from "../../firebase/useFirestore"
import ActivityMeta from "../activities/ActivityMeta"

const EffectActivities = ({effectId}) => {

    const effects = useFirestoreGeneral('OutputEffects', 'ID', effectId || '')

  return (
    <>
    {effects && effects.map((item) => (
        <ul key={item.ID} className='activities-list'>
            {item.Activity && item.Activity.length > 0 ? item.Activity.map((activity) => (
                <li key={activity} className='activities-list-item'>
                    <ActivityMeta id={activity}/>
                </li>
            )) : <li className='activities-list-item'>Geen activiteit(en) geselecteerd</li>}
        </ul>
    ))}
    </>
  )
}

export default EffectActivities